import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { cleanSummaryText } from "../../utils/stringUtils";

export default function ViewSummaryCommon({ btnUi, summaryText, btnText }) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div style={{ display: "inline" }}>
      <span onClick={() => setModalOpen(!modalOpen)}>
        {btnUi || (
          <Button className="trivia-action-button-main" size="sm">
            {btnText || "View Summary"}
          </Button>
        )}
      </span>

      {modalOpen && summaryText ? (
        <Modal isOpen={modalOpen}>
          <ModalHeader
            toggle={() => setModalOpen(false)}
          >
            <div>
              <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '4px' }}>
                Summary
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="p-3">
            <div style={{ fontSize: '14px', color: '#374151', whiteSpace: 'pre-wrap' }}>
              {cleanSummaryText(summaryText)}
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px' }}>
            <Button
              onClick={() => setModalOpen(false)}
              style={{
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 20px',
                borderRadius: '6px',
                backgroundColor: '#f3f4f6',
                border: 'none',
                color: '#374151',
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
}
